import React, { useState, useEffect } from 'react';
import api from './services/api';
import TipoArea from './components/TipoArea';

function App({ lang }) {
  const [terms, setTerms] = useState({});
  const [products, setProducts] = useState({});

  const { tipos, cores } = terms || {};

  useEffect(async () => {
    const { data: termsRes } = await api.get('produtos/v1/terms', {
      params: { lang },
    });
    const { data: products } = await api.get('produtos/v1/list', {
      params: { lang },
    });

    setTerms(termsRes);
    setProducts(products);
  }, []);
  return (
    <div className="container">
      {tipos &&
        products &&
        Object.entries(tipos).map(([, tipo]) => (
          <TipoArea
            key={`tipoa_${tipo.id}`}
            tipo={tipo}
            cores={cores}
            products={products}
          />
        ))}
    </div>
  );
}

export default App;
